'use client';

import config from 'config';
import { ROUTES } from 'constant';
import { useRouter } from 'next/navigation';

import { Box, Stack, useTheme } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import {
  buildLoginUrlWithReturnPath,
  rememberCurrentPageForPostAuthLogin
} from 'utils';

import { Button, Text } from 'ui';

const { booking } = config;

const SeeMore = () => {
  const { userInfo } = useAppSelector((state) => state.persistAuth);
  const router = useRouter();
  const {
    colors: {
      palette: {
        components: { seeMore }
      }
    }
  } = useTheme();

  const handleClick = () => {
    const returnPath = `${window.location.pathname}${window.location.search}`;
    rememberCurrentPageForPostAuthLogin();
    router.push(buildLoginUrlWithReturnPath(ROUTES.login, returnPath));
  };

  return userInfo ? null : (
    <Box mb='30px' w='full'>
      <Stack
        alignItems='center'
        justifyContent='center'
        bg={seeMore.bg}
        padding='30px 20px 20px'
        gap='25px'
        w='100%'
        borderRadius='12px'
      >
        <Text
          fontSize='21px'
          color={seeMore.textColor}
          textAlign='center'
          fontWeight='semibold'
        >
          {booking?.signIn ??
            'Sign In to see your primary location and favorites'}
        </Text>
        <Button
          onClick={handleClick}
          variant='solid'
          colorScheme='black'
          fontWeight={700}
          textTransform='none'
          w='140px'
        >
          Sign In
        </Button>
      </Stack>
    </Box>
  );
};

export default SeeMore;
